import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';

export const TooltipContainer = styled('div')`
  position: relative;
  display: inline-block;
`;

export const TooltipContent = styled('div')`
  transform: translateY(-50%);
  padding: 8px 12px;
  background-color: ${colours.neutral[800]};
  border-radius: 6px;
  white-space: nowrap;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  position: relative;
`;

export const TooltipArrow = styled('div')`
  position: absolute;
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-right-color: ${colours.neutral[800]};
  border-left: none;
  z-index: 10000;
`;

export const TooltipText = styled(Text.P2)`
  color: white;
`;
